import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@prisjakt/ui-inputs';
import * as S from './styles';

const QuickPriceFilters = props => {
  if (!Array.isArray(props.priceFilters)) return null;

  return (
    <>
      {props.priceFilters.map(priceFilter => {
        if (!priceFilter.hasPrices) return false;

        return (
          <S.QuickPriceFilter
            key={priceFilter.name}
            data-test="QuickPriceFilter"
          >
            <Checkbox
              name={priceFilter.name}
              checked={priceFilter.checked}
              onChange={props.onFilterChanged}
              label={priceFilter.label}
            />
          </S.QuickPriceFilter>
        );
      })}
    </>
  );
};

QuickPriceFilters.propTypes = {
  priceFilters: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      checked: PropTypes.bool.isRequired,
      label: PropTypes.string.isRequired,
      hasPrices: PropTypes.bool.isRequired,
    })
  ),
  onFilterChanged: PropTypes.func.isRequired,
};

QuickPriceFilters.defaultProps = {
  priceFilters: [],
};

export default QuickPriceFilters;
